import notification from 'notification-js';
import Config from 'config';
import Uploader from 'html5-uploader';
import EditProfile from './EditProfile';
import EditPassword from './EditPassword';
import AuthDataStorage from "./AuthDataStorage";

export default class Profile {
  constructor({parentElement}) {
    this.authDataStorage = new AuthDataStorage();
    this.parentElement = parentElement;
    this.imageElement = this.parentElement.getElementsByClassName('userAvatar')[0];
    this.getProfile();
    this.userData = {};
    this.setupEvents();
  }

  getProfile() {
    let userData = JSON.parse(this.authDataStorage.getUserData());
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + '/retrieveProfile');
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let profileData = JSON.parse(xobj.response);

        if (profileData.success) {
          this.userData = profileData.user;
          this.showProfile(profileData.user, profileData.teams);
        }
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xobj.setRequestHeader("Auth-Token", userData.token);

    xobj.send(JSON.stringify({id: userData.id}));
  }

  showProfile(userData) {
    let sessionGroupData = JSON.parse(this.authDataStorage.getGroupData());

    let usernameElement = this.parentElement.getElementsByClassName('username')[0];
    let companyNameElement = this.parentElement.getElementsByClassName('companyName')[0];
    let fullnameElement = this.parentElement.getElementsByClassName('fullname')[0];
    let emailElement = this.parentElement.getElementsByClassName('email')[0];

    this.imageElement.src = userData.avatar ? userData.avatar: 'webAssets/images/user.png?v=1';
    usernameElement.innerHTML = userData.username;
    companyNameElement.innerHTML = sessionGroupData.name;
    fullnameElement.innerHTML = userData.firstname + " " + userData.surname;
    emailElement.innerHTML = userData.email;
  }

  setupEvents() {
    this.imageElement = this.parentElement.getElementsByClassName('userAvatar')[0];
    this.editAvatar = this.parentElement.getElementsByClassName('editAvatar')[0];
    this.fileAvatar = this.parentElement.getElementsByClassName('fileAvatar')[0];

    this.editAvatar.onclick = function(event) {
      event.stopPropagation();
      this.fileAvatar.click();
    }.bind(this);

    this.imageElement.onclick = function(event) {
      event.stopPropagation();
      this.fileAvatar.click();
    }.bind(this)

    var uploader = new Uploader({
      el: this.fileAvatar
    });

    uploader.on('files:added', function(files) {
      let FR = new FileReader();
      FR.onload = function(e) {
        this.updateProfile({avatar: e.target.result});
      }.bind(this);
      FR.readAsDataURL(files[0]);
    }.bind(this));

    this.setupButtons();
  }

  setupButtons() {
    this.editProfile = new EditProfile({onsubmit: this.updateProfile.bind(this)});
    this.editPassword = new EditPassword({onsubmit: this.updatePassword.bind(this)});
    let editButton = this.parentElement.getElementsByClassName('editProfile')[0];
    let changePassword = this.parentElement.getElementsByClassName('changePassword')[0];

    editButton.onclick = function(event) {
      this.editProfile.showEditProfile(this.userData);
    }.bind(this)

    changePassword.onclick = function(event) {
      this.editPassword.showEditPassword();
    }.bind(this)
  }

  updateProfile(newData) {
    let sessionUserData = JSON.parse(this.authDataStorage.getUserData());
    let saveProfile = {};

    saveProfile.username = (newData.username) ? newData.username : this.userData.username;
    saveProfile.firstname = (newData.firstname) ? newData.firstname : this.userData.firstname;
    saveProfile.surname = (newData.surname) ? newData.surname : this.userData.surname;
    saveProfile.avatar = (newData.avatar) ? newData.avatar : this.userData.avatar;
    saveProfile.email = (newData.email) ? newData.email : this.userData.email;

    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");

    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let profileData = JSON.parse(xobj.response);

        if (profileData.success) {
          this.editProfile.hideEditProfile();
          this.userData.username = saveProfile.username;
          this.userData.firstname = saveProfile.firstname;
          this.userData.surname = saveProfile.surname;
          this.userData.avatar = saveProfile.avatar;
          this.userData.email = saveProfile.email;
          this.showProfile(this.userData);
          notification.notify( 'success', 'Profile has been updated', {
            notification: {position: [ 'right', 'top' ]}
          });
        } else {
          notification.notify( 'error', profileData.error, {
            notification: {position: [ 'right', 'top' ]}
          });
        }
      }
    }.bind(this);

    if (newData.email && newData.email !== this.userData.email) {
      saveProfile.ID = this.userData.ID;
      saveProfile.email = newData.email;
      xobj.open("POST", Config.BACKEND_URL + '/teams');

      xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xobj.setRequestHeader("Auth-Token", sessionUserData.token);

      xobj.send(JSON.stringify({action: "addUpdateUser", user: saveProfile}));
    } else {
      xobj.open("POST", Config.BACKEND_URL + '/saveProfile');
      xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xobj.setRequestHeader("Auth-Token", sessionUserData.token);

      xobj.send(JSON.stringify({updateFields: saveProfile}));
    }
  }

  updatePassword(newData) {
    let sessionUserData = JSON.parse(this.authDataStorage.getUserData());
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");

    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let passwordData = JSON.parse(xobj.response);

        if (passwordData.success) {
          this.editPassword.hideEditPassword();
          notification.notify( 'success', 'Password has been updated', {
            notification: {position: [ 'right', 'top' ]}
          });
        } else {
          notification.notify( 'error', passwordData.error, {
            notification: {position: [ 'right', 'top' ]}
          });
        }
      }
    }.bind(this);

    xobj.open("POST", Config.BACKEND_URL + '/teams');

    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xobj.setRequestHeader("Auth-Token", sessionUserData.token);

    xobj.send(JSON.stringify({action: "resetUserPassword", passwordData: newData}));

  }
}



// WEBPACK FOOTER //
// ./src/Profile.js